import { OnInit, DoCheck } from '@angular/core';
import { MatSort, MatTableDataSource, MatDialog } from '@angular/material';
import { HttpClient } from "@angular/common/http";
import { FileUploader } from 'ng2-file-upload';
import * as moment from "moment";
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
//snackbar 1
import { MatSnackBar } from '@angular/material';
//ngx-webcam 1
import { Subject } from 'rxjs';
import { WebcamUtil } from 'ngx-webcam';
import { environment } from "environments/environment";
//servicio global
import { GLOBALService } from "../../servicios/functions/GLOBAL.service";
//tabla del jumbotron
var ELEMENT_DATA = [];
var NuevogastoComponent = /** @class */ (function () {
    function NuevogastoComponent(http, // falta el private auth:AuthService
    dialog, datePipe, //para fecha_hoy
    //snackbar 2
    snackBar, global) {
        this.http = http;
        this.dialog = dialog;
        this.datePipe = datePipe;
        this.snackBar = snackBar;
        this.global = global;
        //ngx-webcam 2
        // toggle webcam on/off
        this.showWebcam = true;
        this.allowCameraSwitch = true;
        this.multipleWebcamsAvailable = false;
        this.videoOptions = {};
        this.errors = [];
        // latest snapshot
        this.webcamImage = null;
        // webcam snapshot trigger
        this.trigger = new Subject();
        // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
        this.nextWebcam = new Subject();
        //fin forma
        this.displayedColumns = ['i', 'cod_gasto', 'fecha_ticket', 'detalle', 'importe', 'categoria', 'imagen', 'x'];
        this.dataSource = new MatTableDataSource(ELEMENT_DATA);
        this.viaje = true;
        this.secc = false;
        this.showFiller = false;
        this.uploader = new FileUploader({
            url: environment.backendUrl + "/api/importador/importar",
            itemAlias: 'foto',
            headers: [{ name: 'Access-Control-Allow-Origin', value: '*' }]
        });
        this.strsumi = "";
        this.sumita = 0;
        //forma
        this.papito = new FormGroup({
            'motivo': new FormControl('', [Validators.required, Validators.pattern("^[0-9]{1,5}?$")]),
            'descripcion': new FormControl('', [Validators.required, Validators.pattern("^[0-9]{1,5}?$")]),
        });
        this.detallito = new FormGroup({
            'fecha_ticket': new FormControl('', [Validators.required]),
            //'importe': new FormControl('', [Validators.required, Validators.pattern("^[0-9]{1,5}([.][0-9]{2})?$")]),
            'importe': new FormControl('', [Validators.required, Validators.pattern("[1-9]{1}[0-9]{0,4}([.][0-9]{1,2})?$")]),
            'detalle': new FormControl(''),
            'categoria': new FormControl('', [Validators.required]),
            'autorizante': new FormControl(''),
            'imagen': new FormControl(null)
        });
        this.i = 0;
        console.log(navigator.userAgent);
    }
    NuevogastoComponent.prototype.ngDoCheck = function () {
        console.log(this.estPadre);
        this.suma();
        console.log("STRSUMI: " + this.strsumi);
        console.log("SUMI: " + this.sumi);
        console.log("detallito.importe=" + this.detallito.value.importe);
    };
    NuevogastoComponent.prototype.add = function () {
        var detimp = Number(this.detallito.value.importe);
        this.sumi = this.sumi + detimp;
        if (this.strsumi == "") {
            this.strsumi = this.detallito.value.importe;
        }
        else {
            this.strsumi = (this.strsumi) + "-" + (this.detallito.value.importe);
        }
        this.imim = 0;
        document.getElementById("mat-input-2").focus();
        //document.getElementById("mat-input-2").click();
    };
    NuevogastoComponent.prototype.refresh = function () {
        this.sumi = 0;
        this.strsumi = "";
        this.imim = 0;
        this.detallito.value.importe.reset;
        document.getElementById("mat-input-2").focus();
    };
    NuevogastoComponent.prototype.done = function () {
        this.detallito.value.importe = parseFloat(this.sumi).toFixed(2);
        this.imim = this.detallito.value.importe;
    };
    NuevogastoComponent.prototype.onActivate = function (event) {
        window.scroll(0, 0);
        //or document.body.scrollTop = 0;
        //or document.querySelector('body').scrollTo(0,0)
    };
    NuevogastoComponent.prototype.openDialog = function () {
        var dialogRef = this.dialog.open(NuevogastoComponent);
        dialogRef.afterClosed().subscribe(function (result) {
            console.log("Dialog result: " + result);
        });
    };
    NuevogastoComponent.prototype.fotos = function () {
        if (this.foto == 'si') {
            this.foto = 'no';
        }
        else {
            this.foto = 'si';
        }
    };
    NuevogastoComponent.prototype.llenarCategorias = function () {
        var _this = this;
        //http://localhost:1337/api/llenarcategorias/ver?rol=PAGADOR
        this.http.get(environment.backendUrl + "/api/llenarcategorias/ver?rol=" + this.role)
            .subscribe(function (data) {
            _this.dataSourceCategorias = data;
            console.log(_this.dataSourceCategorias);
        });
    };
    NuevogastoComponent.prototype.deshabilitaRetroceso = function () {
        window.location.hash = "no-back-button";
        window.location.hash = "Again-No-back-button"; //chrome
        window.onhashchange = function () { window.location.hash = "no-back-button"; };
    };
    NuevogastoComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.sumi = 0;
        this.getProximo();
        this.estPadre = 'PENDIENTE';
        console.log(this.i);
        this.deshabilitaRetroceso();
        this.role = localStorage.getItem('role');
        //lleno categorias
        this.llenarCategorias();
        ////ngx-webcam 2
        WebcamUtil.getAvailableVideoInputs()
            .then(function (mediaDevices) {
            _this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
        });
        window.scroll(0, 0);
        this.idsec = this.idsec = localStorage.getItem('seccional');
        this.blanquearTodo();
        this.limpiacam();
        this.foto = 'si';
        this.fecha_hoy = new Date;
        this.fecha_hoy = this.datePipe.transform(this.fecha_hoy, "yyyy-MM-dd");
        this.hora = this.global.horario();
        console.log("fecha: " + this.fecha_hoy);
        console.warn("hora: " + this.hora);
        this.dataSource.sort = this.sort;
        this.userlog = localStorage.getItem('userId');
    };
    //ngx-webcam 3
    NuevogastoComponent.prototype.triggerSnapshot = function () {
        this.trigger.next();
    };
    NuevogastoComponent.prototype.toggleWebcam = function () {
        this.showWebcam = !this.showWebcam;
    };
    NuevogastoComponent.prototype.handleInitError = function (error) {
        this.errors.push(error);
    };
    NuevogastoComponent.prototype.showNextWebcam = function (directionOrDeviceId) {
        // true => move forward through devices
        // false => move backwards through devices
        // string => move to device with given deviceId
        this.nextWebcam.next(directionOrDeviceId);
    };
    NuevogastoComponent.prototype.handleImage = function (webcamImage) {
        console.info('received webcam image', webcamImage);
        this.webcamImage = webcamImage;
        //console.log(this.webcamImage.imageAsDataUrl);
        //hago el resize de la fotodetalle antes de guardarlo
        console.log("resize imagen desde webcam..");
        this.fotodetalle = this.webcamImage.imageAsDataUrl;
    };
    NuevogastoComponent.prototype.cameraWasSwitched = function (deviceId) {
        console.log('active device: ' + deviceId);
        this.deviceId = deviceId;
    };
    Object.defineProperty(NuevogastoComponent.prototype, "triggerObservable", {
        get: function () {
            return this.trigger.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NuevogastoComponent.prototype, "nextWebcamObservable", {
        get: function () {
            return this.nextWebcam.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    NuevogastoComponent.prototype.limpiacam = function () {
        this.showWebcam = false;
        this.fotodetalle = [];
        this.fotodetalle = null;
        this.webcamImage = null;
    };
    // fin ngx-webcam 
    NuevogastoComponent.prototype.ngAfterViewInit = function () {
        //console.log("uploader ready");
        this.uploader.onBeforeUploadItem = function (item) {
            item.withCredentials = false;
        };
        this.uploader.onAfterAddingFile = (function (item) {
            item.withCredentials = false;
        });
        //this.getProximo();
        //this.userlog=localStorage.getItem('userId');
    };
    NuevogastoComponent.prototype.prendeCamara = function () {
        //prende ngx-webcam 4
        this.showWebcam = true;
    };
    NuevogastoComponent.prototype.scrollTop = function () {
        var scrollToTop = window.setInterval(function () {
            var pos = window.pageYOffset;
            if (pos > 0) {
                window.scrollTo(0, pos - 10); // how far to scroll on each step
            }
            else {
                window.clearInterval(scrollToTop);
            }
        }, 5);
    };
    NuevogastoComponent.prototype.apagaCamara = function () {
    };
    NuevogastoComponent.prototype.snackCamara = function () {
        // snackbar si encuentra al usuario
        this.snackBar.open('IMAGEN LISTA!!!', 'Cerrar', { duration: 3000 });
    };
    NuevogastoComponent.prototype.addEvent = function (input, $event) {
        this.selectedDate = moment($event.value).format('YYYY-MM-DD');
    };
    NuevogastoComponent.prototype.getProximo = function () {
        var _this = this;
        //llamo en el afterviewinitss
        this.http.get(environment.backendUrl + "/api/importetotal/total").subscribe(function (data) {
            _this.proximo = data["PROXIMO"];
            //console.log(this.proximo);
        });
    };
    NuevogastoComponent.prototype.guardarDetallito = function () {
        this.i = this.i + 1;
        console.log(this.detallito.value);
        var data = { i: this.i, cod_gasto: this.proximo, fecha_ticket: moment(this.detallito.value.fecha_ticket).format('YYYY-MM-DD'), detalle: this.detallito.value.detalle,
            importe: this.detallito.value.importe, categoria: this.detallito.value.categoria, imagen: this.fotodetalle };
        this.sumita = this.sumita + this.detallito.value.importe;
        ELEMENT_DATA.push(data);
        this.dataSource = new MatTableDataSource(ELEMENT_DATA);
        this.haydetalle = ELEMENT_DATA;
        this.fotodetalle = null;
        this.fotob64 = null;
        this.detallito.reset();
        this.scrollTop();
        this.contarArray();
        this.refresh();
    };
    NuevogastoComponent.prototype.resizeImage = function (base64, maxWidth, maxHeight) {
        // Max size for thumbnail
        if (typeof (maxWidth) === 'undefined')
            maxWidth = 500;
        if (typeof (maxHeight) === 'undefined')
            maxHeight = 500;
        // Create and initialize two canvas
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        var canvasCopy = document.createElement("canvas");
        var copyContext = canvasCopy.getContext("2d");
        // Create original image
        var img = new Image();
        img.src = base64;
        // Determine new ratio based on max size
        var ratio = 1;
        if (img.width > maxWidth)
            ratio = maxWidth / img.width;
        else if (img.height > maxHeight)
            ratio = maxHeight / img.height;
        // Draw original image in second canvas
        canvasCopy.width = img.width;
        canvasCopy.height = img.height;
        copyContext.drawImage(img, 0, 0);
        // Copy and resize second canvas to first canvas
        canvas.width = img.width * ratio;
        canvas.height = img.height * ratio;
        ctx.drawImage(canvasCopy, 0, 0, canvasCopy.width, canvasCopy.height, 0, 0, canvas.width, canvas.height);
        return canvas.toDataURL();
    };
    NuevogastoComponent.prototype.llenarEjemplo = function () {
        this.motivoPadre = 'VIAJE';
        this.detallePadre = 'GASTOS FONDO FIJO';
        this.obsPadre = 'ALGUNA OBSERVACION';
        this.detallito["fecha_ticket"];
        this.detallito = new FormGroup({
            'fecha_ticket': new FormControl('2019-01-01', [Validators.required]),
            'importe': new FormControl('777', [Validators.required, Validators.pattern("^[0-9]{1,5}([.][0-9]{2})?$")]),
            'detalle': new FormControl('GASTO DE INTERNET'),
            'categoria': new FormControl(''),
            'autorizante': new FormControl(''),
            'imagen': new FormControl(null)
        });
    };
    NuevogastoComponent.prototype.guardarDetallitoPrueba = function () {
        this.i = this.i + 1;
        var data = { i: this.i, cod_gasto: this.proximo, fecha_ticket: '2018-12-14', detalle: 'ALGUN GASTO MAX 30c',
            importe: '1233', categoria: '500000-0', imagen: this.fotodetalle };
        ELEMENT_DATA.push(data);
        this.dataSource = new MatTableDataSource(ELEMENT_DATA);
        this.haydetalle = ELEMENT_DATA;
        this.fotodetalle = null;
        this.fotob64 = null;
        this.detallito.reset();
        this.scrollTop();
        this.contarArray();
        this.suma();
    };
    //GENERA NUEVO CODGASTO EN LA BASE Y SUS DETALLES
    NuevogastoComponent.prototype.enviarFormulario = function () {
        var _this = this;
        this.scrollTop();
        this.loading = true;
        //console.log(this.fotodetalle); base64 link de la foto capturada
        if (this.role == 'USER') {
            this.estPadre = 'PENDIENTE';
            this.gastoDePadre = 'PROPIO';
        }
        console.log("*ESTADO: " + this.estPadre);
        console.log(this.detallePadre);
        this.tipo_gasto = 'SISTEMA';
        this.http.post(environment.backendUrl + "/api/nuevodetalle/enviarform", {
            'detallePadre': this.detallePadre,
            'motivoPadre': this.motivoPadre,
            'usuario': this.userlog,
            'fechaPadre': this.fecha_hoy,
            'obsPadre': this.obsPadre,
            'estPadre': this.estPadre,
            'gastoDePadre': this.gastoDePadre,
            'tipo_gasto': this.tipo_gasto,
            'detalles': ELEMENT_DATA
        }).subscribe(function () {
            console.log("NUEVO GASTO GENERADO!");
            _this.global.historicalTo("+NUEVO GASTO [" + _this.proximo + "] - motivo: " + _this.motivoPadre + ", detalle: " + _this.detallePadre + ", total: $" + _this.parcial + ", a las: " + _this.global.horario() + ", est: " + _this.estPadre, 'NUEVO-GASTO');
            _this.haydetalle = null;
            _this.blanquearTodo();
            _this.loading = false;
            //this.llenarNoti();
            _this.snackBar.open('GASTO ENVIADO CORRECTAMENTE!', 'Cerrar', { duration: 3000 });
        });
    };
    NuevogastoComponent.prototype.llenarNoti = function () {
        var _this = this;
        if (this.role == 'PAGADOR') {
            //http://localhost:1337/api/jorgenotifi/noti?est=AUTORIZADO
            this.http.get(environment.backendUrl + "/api/jorgenotifi/noti?est=AUTORIZADO")
                .subscribe(function (data) {
                _this.noti = data[0]["TOT"];
                localStorage.setItem('notipend', _this.noti);
                console.log("noti= " + localStorage.getItem('notipend'));
            });
        }
        else {
            //http://localhost:1337/api/notifi/noti?idse=21&est=PENDIENTE
            this.http.get(environment.backendUrl + "/api/notifi/noti?idse=" + this.idsec + "&est=PENDIENTE")
                .subscribe(function (data) {
                _this.noti = data[0]["TOT"];
                localStorage.setItem('notipend', _this.noti);
                console.log("noti= " + localStorage.getItem('notipend'));
            });
        }
    };
    NuevogastoComponent.prototype.quitarImagen = function () {
        this.fotodetalle = null;
        this.limpiacam();
        this.sumi = 0;
    };
    NuevogastoComponent.prototype.blanquearTodo = function () {
        //padre
        this.detallePadre = null;
        this.motivoPadre = null;
        this.obsPadre = null;
        //detalles
        this.haydetalle = null;
        this.dataSource.data = [];
        this.dataSource.data = null;
        this.foto = null;
        this.fotodetalle = null;
        ELEMENT_DATA = [];
        this.detallito.reset();
        //fotos
        this.fotob64 = null;
        //blanquea fotos
        this.limpiacam();
    };
    NuevogastoComponent.prototype.getFiles = function (event) {
        this.files = event.target.files;
        var reader = new FileReader();
        reader.onload = this._handleReaderLoaded.bind(this);
        reader.readAsDataURL(this.files[0]);
    };
    //obtengo base64 de imagen subida
    NuevogastoComponent.prototype._handleReaderLoaded = function (readerEvt) {
        var b64String = readerEvt.target.result;
        this.fotob64 = b64String;
        //console.log(this.fotob64);
    };
    NuevogastoComponent.prototype.subirImagenDesdePc = function () {
        this.fotodetalle = this.fotob64;
        console.log("resize imagen subida deshabilitado");
        this.fotodetalle = this.fotodetalle;
    };
    NuevogastoComponent.prototype.suma = function () {
        var impbo = 0;
        var cont = 0;
        if (this.dataSource.data) {
            for (var _j = 0; _j < (this.dataSource.data.length); _j++) {
                cont = cont + 1;
                impbo = impbo + Number(this.dataSource.data[_j]["importe"]);
            }
            console.log("parcial: " + impbo);
            console.log("items: " + cont);
        }
        else {
            console.log("TODAVIA NO CARGO NINGUNO");
        }
        this.parcial = impbo;
        this.items = cont;
    };
    NuevogastoComponent.prototype.removeAt = function (x) {
        var impbo = 0;
        console.log("borrando fila nro: " + x);
        //recorre el array y obtiene la posicion donde encuentre el dato a buscar (x)
        var index = this.dataSource.data.indexOf(this.dataSource.data.find(function (h) { return h.i == x; }));
        console.log("posicion del elemento: " + index);
        //borra desde la posicion que le mandas, y la cantidad que desees borrar contando esa posicion
        this.dataSource.data.splice(index, 1);
        this.dataSource.data.push();
        ELEMENT_DATA.push();
        this.dataSource = new MatTableDataSource(ELEMENT_DATA);
        this.contarArray();
    };
    NuevogastoComponent.prototype.contarArray = function () {
        //console.log(this.dataSource.data.length);
        this.registros = this.dataSource.data.length;
    };
    NuevogastoComponent.prototype.enviaItem = function (temp) {
        localStorage.setItem('itemTempo', temp);
        this.temporal = localStorage.getItem("itemTempo");
        console.log(temp);
    };
    return NuevogastoComponent;
}()); //fin clase nuevogasto
export { NuevogastoComponent };
